module.exports = __webpack_public_path__ + "img/editdisabled-new.20329901.svg";